import React, {PureComponent} from 'react';
import './PayPanel.scss';
import conf from 'common/js/conf';
import query from 'common/js/query';
import store from 'common/js/store';
import logger from 'common/js/logger';
import utils from 'common/js/utils';
import Mask from 'common/components/mask/Mask';
import {payUn as pay} from 'common/js/pay';
import loginUtils from 'common/js/login';
import {T} from 'react-toast-mobile';

export default class PayPanel extends PureComponent {
    constructor(props) {
        super(props);

        this.searchStr = query.value;
        this.defaultVal = utils.isWx ? 1 : 0;

        this.payInfo = pay.payInfo || {};
        this.package = {};
        this.submitParam = {};
        this.state = {
            isPaying: false,
            payPackage: this.payInfo.payPackage || [],
            payType: this.payInfo.payType || []
        }


        this.selectValue = this.selectValue.bind(this);
        this.preventClose = this.preventClose.bind(this);
        this.closePaypanel = this.closePaypanel.bind(this);
        this.doPay = this.doPay.bind(this);
    }

    componentDidMount() {
        let self = this;
        this._mounted = true;
        pay.getPayInfo(function(res) {
            if(self._mounted) {
                self.setState({
                    payPackage: res.payPackage,
                    payType: res.payType
                });
                self.currentPaytype = self.state.payType[0] && self.state.payType[0]['payChannel'];
            }
        })
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    /**
     * 发布关闭支付弹窗消息
     */
    closePaypanel() {
        this.props.fClose();
    }

    /**
     * 支付数额选择
     * @param e
     */
    selectValue(e) {
        e && e.stopPropagation();

        if(this.state.isPaying) {
            return;
        }

        var target = e.currentTarget,
            type = target.getAttribute('data-type'),
            identify = target.getAttribute('data-identify');

        this[type=== 'package' ? 'currentBuyway' : 'currentPaytype'] = identify;

        target.parentNode.querySelector(".active").className = "";
        target.className = "active";

    }

    /**
     * 阻止冒泡
     * @param e
     */
    preventClose(e) {
        e.stopPropagation();
    }

    /**
     * 支付
     * @returns {XML}
     */
    doPay(e) {
        let self = this,
            pInfo =  this.package[this.currentBuyway],
            param;

        e.preventDefault();
        e.stopPropagation();

        if(this.state.isPaying){
            return;
        }

        let payTypeParam = {
            yyUid: store.cookie.get("yyuid") || store.cookie.get("udb_uid"),
            paySource: "h5",
            ticket: "",
            ticketType: "",
            cacode: ""
        };
        if(utils.isWx) {
            payTypeParam = {
                yyUid: store.cookie.get("yyuid") || store.cookie.get("udb_uid"),
                paySource: "wechat",
                openId: loginUtils.user.openid
            }
        }

        // 收集支付信息
        this.submitParam.buyWay = pInfo.buyWay;
        this.submitParam.beanNum = pInfo.exchange_bean + pInfo.gift_bean;
        this.submitParam.payTotal = pInfo.pay_money;
        this.submitParam.payType = this.currentPaytype;

        /*if(utils.isDebug) {
            alert("测试环境专用提示----最终会支付0.1元，获取100V币");
            this.submitParam.buyWay = 0;
            this.submitParam.beanNum = 100;
            this.submitParam.payTotal = 0.1;
        }*/


        param = {
            data: Object.assign(this.submitParam, {
                promoter: (this.searchStr && (this.searchStr.promoter || this.searchStr.channel)) || "",
            }, payTypeParam),
            callback: function(res) {
                if(utils.isWx) {
                    self.doPayResponseByWechat(res);
                }else{
                    self.doPayResponse(res);
                }
            }
        }


        this.setState({
            isPaying: true
        });

        this.timer = setTimeout(() =>{
            clearTimeout(this.timer);
            this.setState({
                isPaying: false
            });
            this.closePaypanel();
        }, 2000);

        pay.getTimeSign(param, function() {
            if(self._mounted) {
                self.setState({
                    isPaying: false
                });
            }
        });
    }


    // 公众号支付回调
    doPayResponseByWechat(res) {
        var self = this;
        if(res.status === 200 && res.data !== null) {
            let oInfo = JSON.parse(decodeURIComponent(res.data.payUrl));
            Object.assign(oInfo, {
                callback: function(res) {
                    if(res.errMsg === 'chooseWXPay:ok') {
                        self.showTips({
                            type: 'suc',
                            note:  utils.formatNumber(self.submitParam.beanNum, '万'),
                            txt: 'V币充值成功'
                        });
                    }else if(res.errMsg === 'chooseWXPay:cancel') {
                        self.showTips({
                            type: 'fail',
                            note:  '',
                            txt: '支付已取消'
                        });
                    }else{
                        self.showTips({
                            type: 'fail',
                            note:  '',
                            txt: res.txt || '充值失败，请重试'
                        });
                    }
                }
            });
            pay.evokeWXPay(oInfo)
        }else if(res.status === 501 ) {
            loginUtils.logout();
            this.showTips({
                type: 'fail',
                note:  '',
                txt: '支付失败，请刷新页面重新尝试！'
            });
        }else{
            this.showTips({
                type: 'fail',
                note:  '',
                txt: '订单创建失败'
            });
        }
    }


    // h5支付回调方法
    doPayResponse(res) {
        clearTimeout(this.timer);
        if(res.status == 200) {
            if(res.data && res.data.payUrl) {
                this.setState({
                    isPaying: false
                });

	            if(this.currentPaytype === 'WeixinWap') {
		            console.log(res.data.payUrl);
		            var url = decodeURIComponent(res.data.payUrl).split('data=');
		            var redirectUrl = encodeURIComponent(decodeURIComponent(url[1]).replace(/(redirect_url=)([^&]*)/, ''));
		            res.data.payUrl = encodeURIComponent( url[0] + 'data=' + redirectUrl );
		            if(utils.isAndroid) {
			            this.showTips({
				            type: 'suc',
				            note:  '',
				            txt: '微信唤起中，请稍候...'
			            }, function() {
				            T.confirm({
					            title: '',
					            message: `<p>请确认微信支付是否已完成</p>`,
					            option: [{
						            text: '已完成支付',
						            fn: () => window.location.reload()
					            }, {
						            text: '关闭'
					            }]
				            });
			            });
			            utils.createIframe(decodeURIComponent(res.data.payUrl));
			            return ;
		            }

		            window.location.href = window.location.href + "#redirectwxpay";
	            }

	            window.location.href = decodeURIComponent(res.data.payUrl);
            }
        }else{
            this.showTips({
                type: 'fail',
                note:  '',
                txt: res.msg || '充值失败，请重试'
            });
            logger.warn(res);
        }
    }

    showTips(tips, callback) {
        if(tips.type === 'suc') {
            this.closePaypanel();
        }else{
            this._mounted && this.setState({
                isPaying: false
            });
        }
        this.props.fShowPayTips(tips, callback);

    }

    render() {
        const self = this;
        const props = this.props;
        const source = props.source || 'home';
        const isShowType = utils.isWx ? false : true;

        return (
            <Mask fClose={this.closePaypanel}>
                <div className="m-pay-un" onClick={this.preventClose}>
                    <header className="m-pay_hd">
                        <h3 className="title">{props.topupTitle || 'V币充值'}</h3>
                        <div className="close" onClick={this.closePaypanel}></div>
                    </header>
                    <ul className="m-pay-un_con">
                        {
                            this.state.payPackage.map((value, index) => {
                                self.package[value.buyWay] = value;
                                let iIndex =  index + 1;
                                let selectClass =  'clickstat ';
                                if(index === this.defaultVal) {
                                    selectClass += 'active'
                                    self.currentBuyway = value.buyWay;
                                }

                                return (
                                    <li className={selectClass}
                                        key={index}
                                        data-type="package"
                                        data-stat={'Click/' + source +'/recharge/' + iIndex + '|点击/' + conf['report'][source] + '/送礼/' + iIndex}
                                        data-identify={value.buyWay}
                                        onClick={this.selectValue}>
                                        <div>
                                            <p className="main">{utils.formatNumber(value.exchange_bean, "万")}</p>
                                            <p className="des">{value.pay_money}元</p>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {isShowType ? <ul className="m-pay-un_con m-pay-un_way">
                        {
                            this.state.payType.map((value, index) => {
                                let iIndex = index + 1;

                                return (
                                    <li className={index === 0 ? 'active clickstat' : 'clickstat'}
                                        key={index}
                                        data-stat={'Click/' + source + '/buyway/' + iIndex + '|点击/' + conf['report'][source] + '/支付方式/' + iIndex}
                                        data-identify={value.payChannel}
                                        onTouchEnd={this.selectValue}>
                                        <div>
                                            <p className="font">{value.payDesc}</p>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul> : null
                    }
                    <div className="m-pay-un_bd">
                        <a href="javascript:void(0)" className="b-pay clickstat" data-stat={'Click/' + source + '/recharge/pay|点击/' + conf['report'][source] + '/充值/支付'} onTouchEnd={this.doPay} >{this.state.isPaying ? "处理中..." : "确认支付"}</a>
                    </div>
                </div>
            </Mask>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/pay-panel/PayPanel.jsx